import styles from "../../ProductsRPDesigner.module.scss";
import { Button } from "@mui/material";

function GSLanguage ({ createEnabled, openLanguagesDetail }) {

    return (
        <div className={styles["sec--products--rpdesigner--colors"]}>
            <Button id="openLanguages" fullWidth variant="contained" color="primary" onClick={openLanguagesDetail} name="languages">Languages</Button>
        </div>
    )
}

export default GSLanguage;